import chroma from 'chroma-js'

const scoreColors = ['ffbfbf', 'ffc3a5', 'FFE768', '8ED1A5', '00441b']

/**
 * Get color for a score value using a color scale
 * @param score - The score value (default: 0)
 * @param value - The maximum value for the scale (default: 100)
 * @returns Hex color string
 */
export const getScoreColor = (score = 0, value = 100): string =>
  chroma
    .scale(scoreColors)(score / value)
    .hex()
